/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useEffect, useContext } from "react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import EvhrPrint from "components/evhrPrintV2";
import { UserContext } from "utils/reducers/user";
import AddConsignment from "components/addConsignments";
import { useUpdateKioskAfterCompletion } from "utils/apis/kiosk.api";
import { useUpdateCollectionAfterCompletion } from "utils/apis/collections.api";
import { useUpdateB2BAfterCompletion } from "utils/apis/b2b.api";
import { useUpdateExchangeAfterCompletion } from "utils/apis/exchange-service.api";
import { useUpdateInterBranchAfterCompletion } from "utils/apis/inter-branch.api";

function CollectedConsignmentsDetail({
  consignments,
  type,
  request,
  count,
}: {
  type:
    | "Kiosk Service"
    | "Collection"
    | "Exchange"
    | "B2B"
    | "InterBranch"
    | "Delivery"
    | "Replenishment"
    | "Clearance";
  consignments: any;
  request: any;
  count: number;
}) {
  const { vhrNo, vhrs } = consignments || {
    vhrNo: null,
    vhrs: [],
  };

  return (
    <>
      {vhrNo ? (
        <div className="flex items-center justify-between mb-5">
          <h3 className="font-semibold text-2xl">{`VHR No: ${vhrNo}`}</h3>

          <EvhrPrint
            consignments={consignments}
            type={type}
            request={request}
            count={count}
          />
        </div>
      ) : null}
      {vhrs?.map((vhr: any) => (
        <DisplayGrid
          key={vhr.containerId}
          type={type}
          data={vhr}
          request={request}
        />
      ))}
    </>
  );
}

function DisplayGrid({
  data,
  type,
  request,
}: {
  data: any;
  type:
    | "Kiosk Service"
    | "Collection"
    | "Exchange"
    | "B2B"
    | "InterBranch"
    | "Delivery"
    | "Replenishment"
    | "Clearance";
  request: any;
}) {
  const { vhrNo, containers, isTGDelivery } = data || {
    vhrNo: null,
    containers: [],
    isTGDelivery: false,
  };
  const user = useContext(UserContext);

  const [bagContainers, setBagContainers] = useState<any[]>([]);

  const {
    mutate: updateKioskBags,
    isPending: kioskPending,
    isSuccess: kioskSuccess,
  } = useUpdateKioskAfterCompletion();

  const {
    mutate: updateCollectionBags,
    isPending: collectionPending,
    isSuccess: collectionSuccess,
  } = useUpdateCollectionAfterCompletion();

  const {
    mutate: updateB2bBags,
    isPending: b2bPending,
    isSuccess: b2bSuccess,
  } = useUpdateB2BAfterCompletion();

  const {
    mutate: updateExchangeBags,
    isPending: exchangePending,
    isSuccess: exchangeSuccess,
  } = useUpdateExchangeAfterCompletion();

  const {
    mutate: updateInterBranchBags,
    isPending: interBranchPending,
    isSuccess: interBranchSuccess,
  } = useUpdateInterBranchAfterCompletion();

  function DetailComponent({ dataItem }: any) {
    const copyData = dataItem.packedCurrencies || [];
    if (copyData && copyData.length > 0) {
      return (
        <Grid data={copyData} style={{ width: "100%" }}>
          <GridColumn field="currency" title="Currency" />
          <GridColumn field="declaredValue" title="Declared Value" />
          <GridColumn field="exchangeRate" title="Exchange Rate" />
        </Grid>
      );
    }
    return <div style={{ height: "0px", width: "100%" }} />;
  }

  const expandChange = (event: { dataItem: any; value: boolean }) => {
    event.dataItem.expanded = event.value;
    setBagContainers([...bagContainers]);
  };

  const onEditAssignedBags = (bags: any) => {
    const payload = {
      requestId: request?.requestId,
      jobNo: request?.jobNo,
      isTGDelivery,
      collectionVhr: {
        vhrNo,
        vhrEditType: data?.vhrEditType,
        corelationId: data?.corelationId,
        containers: bags,
      },
    };
    if (type === "Kiosk Service") {
      updateKioskBags(payload);
    } else if (type === "Collection") {
      updateCollectionBags({
        requestId: request?.requestId,
        vhrs: [
          {
            vhrNo,
            vhrEditType: data?.vhrEditType,
            corelationId: data?.corelationId,
            containers: bags,
          },
        ],
      });
    } else if (type === "Exchange") {
      updateExchangeBags(payload);
    } else if (type === "B2B") {
      updateB2bBags(payload);
    } else if (type === "InterBranch") {
      updateInterBranchBags(payload);
    }
  };

  useEffect(() => {
    if (containers?.length) {
      setBagContainers([...containers]);
    } else if (!containers?.length) {
      setBagContainers([]);
    }
  }, [containers]);

  return (
    <>
      <div className="flex justify-end mb-3">
        {vhrNo &&
        ((["Out for Delivery"].includes(request?.status) &&
          request?.isBranchToATM) ||
          ["Completed", "Pending", "Collected", "Awaiting Delivery"].includes(
            request?.status,
          )) &&
        (user.Roles.includes("PA Supervisor") ||
          user.Roles.includes("PA Assistant")) ? (
          <AddConsignment
            isTGDelivery={isTGDelivery}
            isEdit
            type={type}
            onConfirm={onEditAssignedBags}
            isLoading={
              kioskPending ||
              collectionPending ||
              b2bPending ||
              exchangePending ||
              interBranchPending
            }
            isSuccess={
              kioskSuccess ||
              collectionSuccess ||
              b2bSuccess ||
              exchangeSuccess ||
              interBranchSuccess
            }
            bags={bagContainers}
            defaultBagType="AED"
          />
        ) : null}
      </div>
      <Grid
        data={bagContainers}
        detail={DetailComponent}
        expandField="expanded"
        onExpandChange={expandChange}
        className="mb-3"
      >
        <GridColumn field="containerType" title="Bag Type" />
        <GridColumn field="containerId" title="Bag Id" />
        <GridColumn field="details" title="Details" />
        <GridColumn field="currency" title="Currency" />
        <GridColumn field="declaredValue" title="Value" format="{0:N2}" />
        <GridColumn field="localValue" title="Local Value" format="{0:N2}" />
        <GridColumn
          field="count"
          title="Count"
          cell={({ dataItem }) => (
            <td>{dataItem?.chequePieces || dataItem?.count}</td>
          )}
        />
        {["Kiosk Service", "Exchange", "B2B"].includes(type) && (
          <GridColumn field="returnedCount" title="Returned Count" />
        )}
        <GridColumn field="sealNo" title="Seal No" />
        {["Kiosk Service", "Exchange", "B2B"].includes(type) && (
          <GridColumn field="status" title="Status" />
        )}
        <GridColumn field="remarks" title="Remarks" />
      </Grid>
    </>
  );
}

export default CollectedConsignmentsDetail;
